import React from 'react';
import { ProductTypes } from '../../../../types/product/product';
import useStyle from './productCardMosaicItem.style';
import ProductCardHeader from './ProductCardHeader/productCardHeader';
import ProductCardFooter from './ProductCardFooter/ProductCardFooter';
import { classNames } from 'helpers/style/classNames';
import ProductCardBody from './ProductCardBody/ProductCardBody';

export interface ProductCardMosaicItemProps {
  product: ProductTypes;
  onClick: () => void;
  onAddToCart;
  setProductQuantity;
  isOut?: boolean;
  isPublicShop?: boolean;
}

const ProductCardView = ({
  product,
  onClick,
  onAddToCart,
  setProductQuantity,
  isOut = false,
  isPublicShop = false
}: ProductCardMosaicItemProps) => {
  const classes = useStyle();

  return (
    <div
      className={classNames([classes.root], {
        condition: isOut,
        classe: classes.empty
      })}
    >
      <ProductCardHeader
        product={product}
        className={classes.media}
        onClick={onClick}
      />
      <ProductCardBody
        product={product}
        onClick={onClick}
        isPublicShop={isPublicShop}
      />
      <ProductCardFooter
        onClick={onClick}
        onAddToCart={onAddToCart}
        setProductQuantity={setProductQuantity}
        isOut={isOut}
      />
    </div>
  );
};

export default ProductCardView;
